/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UnsetUserGachaEnhancementResponse } from '../../models/unset-user-gacha-enhancement-response';

export interface UserServiceUnsetUserGachaEnhancement2$Params {
  userUuid: string;
  gachaInstanceId: string;
  discordId?: string;
  gachaId?: string;
}

export function userServiceUnsetUserGachaEnhancement2(http: HttpClient, rootUrl: string, params: UserServiceUnsetUserGachaEnhancement2$Params, context?: HttpContext): Observable<StrictHttpResponse<UnsetUserGachaEnhancementResponse>> {
  const rb = new RequestBuilder(rootUrl, userServiceUnsetUserGachaEnhancement2.PATH, 'delete');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.path('gachaInstanceId', params.gachaInstanceId, {});
    rb.query('discordId', params.discordId, {});
    rb.query('gachaId', params.gachaId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UnsetUserGachaEnhancementResponse>;
    })
  );
}

userServiceUnsetUserGachaEnhancement2.PATH = '/api/v3/gateway/user/{userUuid}/gacha/instance/{gachaInstanceId}/enhancement';
